import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, CssVarsProvider, GlobalStyles } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { theme } from './__legacy__/theme/Theme';

export const GLOBAL_NONCE = document.querySelector<HTMLMetaElement>('meta[name="nonce"]')?.content ?? '';

export const ThemeProvider = observer((props: PropsWithChildren): ReactElement => {
  const styleCache = createCache({
    key: 'act',
    nonce: GLOBAL_NONCE,
  });

  return (
    <CacheProvider value={styleCache}>
      <CssVarsProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            '.svg-inline--fa': {
              color: 'var(--Icon-color)',
              fontSize: 'var(--Icon-fontSize, 20px)',
              height: '0.875em',
            },
          }}
        />
        {props.children}
      </CssVarsProvider>
    </CacheProvider>
  );
});
